// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"467174e7","453":"fa7a0f2d"}[chunkId] + ".chunk.js";
};